import 'scss/museum.scss';
import { initA11yContrast } from './modules/contrast';
import { initHorizontalScroll } from './modules/horizontal-scroll';
import { initNav } from './modules/nav';
import { initMenuOverlay } from './modules/menu-overlay';
import { initAnalytics } from './modules/analytics';
import { initCookieBanner } from './modules/cookie-banner';
import { initHeroCard } from './modules/hero-card';
import { initHeroesSearch } from './modules/heroes-search';
import { initHeroesListMore } from './modules/heroes-list-more';

/**
 * Тема: мобильное меню, контраст, горизонтальная прокрутка, баннер cookie.
 */
initNav();
initMenuOverlay();
initA11yContrast();
initHorizontalScroll();
initCookieBanner();
initHeroCard();
initHeroesSearch();
initHeroesListMore();
initAnalytics();
